/**
 * @summary NextJs deprecated the use of process.browser
 * @returns Boolean
 */
export default function isBrowser(): boolean {
  return typeof window !== 'undefined';
}
